<template>
    <b-input v-bind="additionalInputAttributes" class="form-control" :name="id"
             :state="state" type="date" :value="date" @change="handleChange"/>
</template>

<script>
import DatepickerMixin from '@components/form/DatepickerMixin';

export default {
    mixins: [DatepickerMixin],
}
</script>
